export const SHOP_LOGO_SIZES = {
  signupPreview: 128,
  profilePreview: 128,
  mapPopup: 76,
  previewCard: 80,
  vehicleListCard: 72,
  vehicleMapPopup: 56,
};
